// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  FETCH_DEALS: `${environment.apiUrl}/product-deal/list`,
});

export const fetchDealsApi = getCreator(fetch, endpoints.FETCH_DEALS);



// WEBPACK FOOTER //
// ./src/modules/best-deals/api.js